/** @flow */

import React from "react";
import { Provider } from "react-redux";
import I18n from "redux-i18n";
import { LayoutProvider } from "react-page-layout";
import loginActionCreators from "@modules/account/actionCreator";
import { LicenseManager } from "ag-grid-enterprise";

import http from "@http";
import { translations } from "@translations";
import { LoginLayout, DashboardLayout, CommonLayout } from "@layouts";
import { SessionProvider } from "./session";
import Router from "./routes";
import { isStaticPage } from "@selectors/index";

import "@styles/theme.style.scss";

LicenseManager.setLicenseKey(
  "CompanyName=REMEDIO SYSTEMS DEVELOPMENT LIMITED,LicensedApplication=Insight,LicenseType=SingleApplication,LicensedConcurrentDeveloperCount=4,LicensedProductionInstancesCount=1,AssetReference=AG-031032,SupportServicesEnd=4_September_2023_[v2]_MTY5Mzc4MjAwMDAwMA==be551affa795a9cb67588164af165b33",
);

const layouts = {
  public: LoginLayout,
  dashboard: DashboardLayout,
  common: CommonLayout,
};

type Props = $Exact<{
  store: Object,
  history: Object,
}>;

class App extends React.Component<Props> {
  componentDidMount() {
    // call profile me only for private page
    if (!isStaticPage()) {
      this.props.store.dispatch(loginActionCreators.checkLogin());
    }
  }

  shouldComponentUpdate() {
    return false;
  }

  render() {
    return (
      <LayoutProvider layouts={layouts}>
        <Provider store={this.props.store}>
          <I18n translations={translations} initialLang="en" fallbackLang="en" useReducer={false}>
            <SessionProvider http={http}>
              <Router history={this.props.history} />
            </SessionProvider>
          </I18n>
        </Provider>
      </LayoutProvider>
    );
  }
}

export default App;
